import React from 'react';
export function Footer() {
  const footerLinks = {
    product: [{
      name: 'Certified Company Database',
      href: 'https://www.certifiedlaravelcompany.com/'
    }, {
      name: 'Certification for Laravel Exams',
      href: 'https://certificationforlaravel.com/'
    }, {
      name: 'Certified Developer Database',
      href: '#'
    }],
    company: [{
      name: 'About',
      href: '#about'
    }, {
      name: 'Contact',
      href: 'mailto:contact@certificationforlaravel.org'
    }],
    legal: [{
      name: 'Terms',
      href: 'https://certificationforlaravel.com/terms-of-service'
    }, {
      name: 'Privacy',
      href: 'https://certificationforlaravel.com/privacy-statement'
    }],
    community: [{
      name: 'Medium',
      href: 'https://medium.com/@certificationforlaravel'
    }, {
      name: 'LinkedIn',
      href: 'https://www.linkedin.com/company/certificationforlaravel'
    }, {
      name: 'Telegram',
      href: 'https://t.me/certificationforlaravel'
    }]
  };
  return <footer className="bg-gray-50 pt-12 sm:pt-16 pb-6 sm:pb-8" data-id="element-57">
      <div className="container mx-auto px-4 max-w-7xl" data-id="element-58">
        <div className="flex justify-center mb-8 sm:mb-12" data-id="element-59">
          <img src="https://cdn.magicpatterns.com/uploads/e5BUmyxLnn3e5mAPwSBoue/Recruitmenttest_logo_website.png" alt="Recruitment Test for Laravel" className="h-10 sm:h-12 mix-blend-multiply" data-id="element-60" />
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 sm:gap-10 mb-12 sm:mb-16" data-id="element-61">
          <div data-id="element-62">
            <h3 className="font-semibold text-gray-900 mb-4 sm:mb-5 text-sm sm:text-base" data-id="element-63">
              Product
            </h3>
            <ul className="space-y-2 sm:space-y-3" data-id="element-64">
              {footerLinks.product.map((link, index) => <li key={index} data-id="element-65">
                  <a href={link.href} className="text-sm sm:text-base text-gray-600 hover:text-primary transition-colors" data-id="element-66">
                    {link.name}
                  </a>
                </li>)}
            </ul>
          </div>
          <div data-id="element-67">
            <h3 className="font-semibold text-gray-900 mb-4 sm:mb-5 text-sm sm:text-base" data-id="element-68">
              Company
            </h3>
            <ul className="space-y-2 sm:space-y-3" data-id="element-69">
              {footerLinks.company.map((link, index) => <li key={index} data-id="element-70">
                  <a href={link.href} className="text-sm sm:text-base text-gray-600 hover:text-primary transition-colors" data-id="element-71">
                    {link.name}
                  </a>
                </li>)}
            </ul>
          </div>
          <div data-id="element-72">
            <h3 className="font-semibold text-gray-900 mb-4 sm:mb-5 text-sm sm:text-base" data-id="element-73">
              Legal
            </h3>
            <ul className="space-y-2 sm:space-y-3" data-id="element-74">
              {footerLinks.legal.map((link, index) => <li key={index} data-id="element-75">
                  <a href={link.href} className="text-sm sm:text-base text-gray-600 hover:text-primary transition-colors" data-id="element-76">
                    {link.name}
                  </a>
                </li>)}
            </ul>
          </div>
          <div data-id="element-77">
            <h3 className="font-semibold text-gray-900 mb-4 sm:mb-5 text-sm sm:text-base" data-id="element-78">
              Community
            </h3>
            <ul className="space-y-2 sm:space-y-3" data-id="element-79">
              {footerLinks.community.map((link, index) => <li key={index} data-id="element-80">
                  <a href={link.href} className="text-sm sm:text-base text-gray-600 hover:text-primary transition-colors" data-id="element-81">
                    {link.name}
                  </a>
                </li>)}
            </ul>
          </div>
        </div>
        <div className="border-t border-gray-200 pt-6 sm:pt-8 text-center text-gray-600 text-xs sm:text-sm px-4" data-id="element-82">
          <p data-id="element-83">
            © 2026 Certification for Laravel – Community Built, Verified by
            Experts
          </p>
        </div>
      </div>
    </footer>;
}